import { AdminShell } from "@project/admin/components/admin-shell";
import {
  ResourceTable,
  type Field,
} from "@project/admin/components/resource-table";

const fields: Field[] = [
  {
    name: "donor_id",
    label: "Donor",
    required: true,
    showInTable: true,
    lookup: {
      table: "donors",
      labelField: "full_name",
      secondaryField: "mobile",
    },
  },
  {
    name: "resident_id",
    label: "Resident",
    showInTable: true,
    lookup: {
      table: "residents",
      labelField: "full_name",
      secondaryField: "resident_code",
    },
  },
  {
    name: "monthly_amount",
    label: "Monthly Amount (₹)",
    type: "number",
    required: true,
    showInTable: true,
  },
  {
    name: "frequency",
    label: "Frequency",
    type: "select",
    options: [
      { value: "monthly", label: "Monthly" },
      { value: "quarterly", label: "Quarterly" },
      { value: "yearly", label: "Yearly" },
      { value: "one_time", label: "One-time" },
    ],
    showInTable: true,
  },
  { name: "start_date", label: "Start Date", type: "date", showInTable: true },
  { name: "end_date", label: "End Date", type: "date" },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "active", label: "Active" },
      { value: "paused", label: "Paused" },
      { value: "completed", label: "Completed" },
    ],
    showInTable: true,
  },
  { name: "notes", label: "Notes", type: "textarea" },
];

export default function Page() {
  return (
    <AdminShell
      title="Adoption Scheme"
      subtitle="Donor sponsorship of residents"
    >
      <ResourceTable
        table="adoption_sponsorships"
        title="Sponsorship"
        fields={fields}
        searchFields={["donor_id", "resident_id", "status"]}
      />
    </AdminShell>
  );
}
